import { ReactComponent as SearchIcon } from "assets/img/icons/search.svg";
import { ReactComponent as SearchCross } from "assets/img/icons/SearchCross.svg";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

interface ISearchFieldProps {
  handleSearch: any;
  reset?: any;
  placeholder: string;
  isVisible?: boolean;
}
const SearchField: React.FC<ISearchFieldProps> = (props) => {
  const { placeholder, handleSearch, reset, isVisible } = props;
  const [searchValue, setSearchValue] = useState(reset !== undefined ? reset : "");

  const cleanSearchField = () => {
    setSearchValue("");
    handleSearch("");
  };

  const handleOnChange = (value: any) => {
    setSearchValue(value);
    if (!value || value.length === 0) {
      handleSearch("");
    }
  };

  const formSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (searchValue === "") {
      cleanSearchField();
      handleSearch("");
      return;
    }
    if (searchValue.trim().length > 0) handleSearch(searchValue);
  };

  useEffect(() => {
    setSearchValue(reset);
  }, [reset]);

  return (
    <>
      <Wrapper>
        <div className="search-wraper">
          <form onSubmit={(e) => formSubmit(e)}>
            <div className="search-bar">
              <span className="refresh-search" onClick={formSubmit}>
                <SearchIcon />
              </span>
              <input
                type="text"
                name="search"
                className="search-input"
                placeholder={placeholder}
                onChange={(e) => handleOnChange(e.target.value)}
                value={searchValue}
              />
              {searchValue ? (
                <span onClick={() => cleanSearchField()} className="clear-search">
                  <SearchCross />
                </span>
              ) : null}
            </div>
          </form>
        </div>
      </Wrapper>
    </>
  );
};

export default SearchField;

const Wrapper = styled.div`
  width: 100%;
  .search-wraper {
    position: relative;
    width: 100%;

    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      span.clear-search {
        float: right;
        margin-top: 5px;
        margin-right: 12px;
        transition: 0.5s;
        cursor: pointer;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 2px;
          margin-bottom: 3px;
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 4px 8px 7px 8px;
        float: left;
        cursor: pointer;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          /* margin: 3px 7px 3px 7px; */
          line-height: 12px;
        }
        svg path {
          fill: #424b50;
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 70px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 14px;
        margin-top: 5px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
`;
